export default __webpack_public_path__ + "static/media/arrowRight.9b5e6b61.svg";